// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gallery-item[data-v-e01fed62]{width:calc(var(--ratio)*6rem)}@media (min-width:1024px){.gallery-item[data-v-e01fed62]{width:calc(var(--ratio)*8rem)}}.ratio[data-v-e01fed62]{height:0;overflow:hidden;padding-bottom:calc(100%/var(--ratio));position:relative;width:100%}.ratio>*[data-v-e01fed62]{height:100%;left:0;position:absolute;top:0;width:100%}.gallery[data-v-e01fed62]{display:flex;flex-wrap:wrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
